module.exports = __webpack_public_path__ + "static/media/MIAB9969-180731-142_Small.05ca8fef.jpg";